import React from 'react';

import classNames from 'classnames';

import classes from './SolutionItemList.module.scss';
import { SidebarGroup } from '../SidebarGroup/SidebarGroup';
import { GroupItem } from '../../../../../interfaces/system/SidebarNavConfig';
import { useScrollEdges } from '../../../hooks/useScrollEdges';
import { useSidebarContext } from '../../../hooks/SidebarContext';

type SolutionItemListProps = {
  groups: GroupItem[];
};

/**
 * Scrollable item list of an expanded solution with "more items" fades at the scroll edges.
 * Mounted only while the solution is expanded, so scroll position and edge state reset on switch.
 */
const SolutionItemList = ({ groups }: SolutionItemListProps) => {
  const { scrollerRef, canScrollUp, canScrollDown } = useScrollEdges();
  const { isCollapsed } = useSidebarContext();

  return (
    <div
      className={classNames(classes.scrollArea, {
        [classes.canScrollUp]: canScrollUp,
        [classes.canScrollDown]: canScrollDown,
      })}
    >
      <div
        ref={scrollerRef}
        className={classNames(classes.content, {
          [classes.collapsed]: isCollapsed,
        })}
      >
        {groups.map((group, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <SidebarGroup group={group} key={index} />
        ))}
      </div>
    </div>
  );
};

export { SolutionItemList };
